module.exports = __webpack_public_path__ + "static/media/linkedInGeminiNew.2b93d4ad.png";